import {SimpleBlueButton} from '../../core/button'
import {HelpIcon, SetReminderIcon, SimpleCheckIcon} from '../../../icons'
import {Formik} from 'formik'
import {useDispatch} from 'react-redux'
import {addReminder, deleteReminder, getSslAndTldData, updateReminder} from '../../../stores/monitoring'
import {useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import ButtonLoader from '../../core/button/ButtonLoader'
import {reminderSchema} from '../../../utils/validation'
import FormHelper from '../../../utils/forms'
import Tooltip from '../../core/tooltip'
import reminders from '../../../data/reminders.json'
import LimitManager from '../../../utils/limitManager'
import CustomSelect from '../../core/customSelect'
import {colors} from '../../../utils/colors'
import RenderedForPaid from '../RenderedForPaid'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const ReminderPopup = ({type, data, closeModal}) => {
    const text = useNamespaceTranslations('monitoring')
    const usageLimitsData = useNamespaceTranslations('usage-limits')
    const deviceHeight = window.innerHeight
    const popupMaxHeight = 832
    const [isButtonDisabled, setIsButtonDisabled] = useState(true)
    const [showButtonLoader, setShowButtonLoader] = useState(false)
    const [isValidationEnabled, setIsValidationEnabled] = useState(false)
    const isSSLReminderDisabled = !LimitManager.getSSLReminderIsEnabled(usageLimitsData)
    const isTLDReminderDisabled = !LimitManager.getTLDReminderIsEnabled(usageLimitsData)
    const disabledStatus = type === reminders.ssl.type ? isSSLReminderDisabled : isTLDReminderDisabled

    const {id} = useParams()
    const dispatch = useDispatch()

    const options = FormHelper.getReminderOptions(1, 60, text)

    const initialValues = {
        days_before: options.filter(item => data?.days_before?.includes(item.value))
    }

    const setButtonActions = () => {
        setIsButtonDisabled(true)
        setShowButtonLoader(true)
    }

    const onSubmit = async(values, {setFieldError}) => {
        const formData = {
            days_before: values?.days_before?.map(item => Number(item?.value))
        }

        setButtonActions()

        if (!data?.days_before) {
            await dispatch(addReminder(type, id, formData, setFieldError, closeModal))
            dispatch(getSslAndTldData(id, false))
            return
        }

        if (!!values.days_before.length && JSON.stringify(formData?.days_before) !== JSON.stringify(data?.days_before)) {
            await dispatch(updateReminder(type, id, formData, setFieldError, closeModal))
            dispatch(getSslAndTldData(id, false))
            return
        }

        if (!values?.days_before.length) {
            const success = await dispatch(deleteReminder(type, id, closeModal))
            if (success) {
                dispatch(getSslAndTldData(id, false))
            }
        }
    }

    const getSaveButtonStatus = value => {
        JSON.stringify(value.map(item => Number(item?.value))) !== JSON.stringify(data?.days_before) ?
            setIsButtonDisabled(false) :
            setIsButtonDisabled(true)
    }

    useEffect(() => {
        !data?.days_before ? setIsValidationEnabled(true) : setIsValidationEnabled(false)
    }, [data])

    return (
        <div className="modal-body">
            <span className={`bg-svg ${deviceHeight < popupMaxHeight ? 'disable' : ''}`}><SetReminderIcon/></span>
            <h4 className="reminder-title">{text.set_reminder_popup_title}</h4>
            <p className="reminder-desc">{type === reminders.ssl.type ? text.set_reminder_popup_ssl_desc : text.set_reminder_popup_tld_desc}</p>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validateOnBlur={false}
                validationSchema={isValidationEnabled && reminderSchema()}
                onSubmit={onSubmit}
                validateOnChange={false}>
                {({handleSubmit, setFieldValue, errors, values}) => (
                    <form onSubmit={handleSubmit} className="modal-body">
                        <div className="reminder-selectbox">
                            <CustomSelect
                                onChange={(name, value) => {
                                    setFieldValue(name, value)
                                    getSaveButtonStatus(value)
                                }}
                                name="days_before"
                                isMulti
                                limit={10}
                                error={errors?.days_before}
                                options={options}
                                placeholder={text.reminder}
                                isDisabled={disabledStatus}
                                value={values.days_before}
                            />
                            <Tooltip
                                placement="right"
                                trigger="click"
                                content={type === reminders.ssl.type ? text.select_info_ssl : text.select_info_tld}
                            >
                                <HelpIcon stroke={colors.colorBgFilter} width="22" height="22"/>
                            </Tooltip>
                        </div>
                        {disabledStatus && <RenderedForPaid forPaidText={text.for_paid}/>}
                        <SimpleBlueButton
                            disabled={disabledStatus || isButtonDisabled}
                            type="submit">
                            {showButtonLoader && <ButtonLoader/>}
                            {text.save}
                            <SimpleCheckIcon/>
                        </SimpleBlueButton>
                    </form>
                )}
            </Formik>
        </div>
    )
}

export default ReminderPopup
